// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"221":"33838a72","583":"10354fc0"}[chunkId] + ".chunk.css";
};